import {
    SAVINGS_WITHOUT_CONDITION_WITHOUT_TERM,
    SAVINGS_WITHOUT_CONDITION_WITH_TERM,
    SAVINGS_WITH_CONDITION_WITH_TERM,
    SAVINGS_WITH_CONDITION_WITHOUT_TERM
} from 'constants/eAccountLoan'

const CONTEXT = 'contractsView'

export const POE_KEYS = {
    [SAVINGS_WITHOUT_CONDITION_WITHOUT_TERM]: {
        profitabilities: [
            { rate: `${CONTEXT}-savingsRates_SBSP`, condition: `${CONTEXT}-savingsConditions_SBSP` },
        ],
        examples: [
            `${CONTEXT}-savingsRepresentativeExample_SBSP`,
        ],
        rates: `${CONTEXT}-savingsRates_SBSP`,
        conditions: `${CONTEXT}-savingsConditions_SBSP`,
        example: `${CONTEXT}-savingsRepresentativeExample_SBSP`,
    },
    [SAVINGS_WITHOUT_CONDITION_WITH_TERM]: {
        profitabilities: [
            { rate: `${CONTEXT}-savingsRates_SBCP`, condition: `${CONTEXT}-savingsConditions_SBCP` },
        ],
        examples: [
            `${CONTEXT}-savingsRepresentativeExample_SBCP`,
        ],
        rates: `${CONTEXT}-savingsRates_SBCP`,
        conditions: `${CONTEXT}-savingsConditions_SBCP`,
        example: `${CONTEXT}-savingsRepresentativeExample_SBCP`,
    },
    [SAVINGS_WITH_CONDITION_WITHOUT_TERM]: {
        profitabilities: [
            { rate: `${CONTEXT}-savingsRates_CBSP`, condition: `${CONTEXT}-savingsConditions_CBSP` },
            { rate: `${CONTEXT}-savingsDoubleProfitability_CBSP`, condition: `${CONTEXT}-savingsDoubleConditions_CBSP` },
        ],
        examples: [
            `${CONTEXT}-savingsRepresentativeExample_CBSP`,
            `${CONTEXT}-savingsDoubleProfitabilityRepresentativeExample_CBSP`,
        ],
        rates: `${CONTEXT}-savingsRates_CBSP`,
        conditions: `${CONTEXT}-savingsConditions_CBSP`,
        doubleProfitability: `${CONTEXT}-savingsDoubleProfitability_CBSP`,
        doubleConditions: `${CONTEXT}-savingsDoubleConditions_CBSP`,
        example: `${CONTEXT}-savingsRepresentativeExample_CBSP`,
        doubleProfitabilityExample: `${CONTEXT}-savingsDoubleProfitabilityRepresentativeExample_CBSP`,
    },
    [SAVINGS_WITH_CONDITION_WITH_TERM]: {
        profitabilities: [
            { rate: `${CONTEXT}-savingsRates_CBCP`, condition: `${CONTEXT}-savingsConditions_CBCP` },
            { rate: `${CONTEXT}-savingsDoubleProfitability_CBCP`, condition: `${CONTEXT}-savingsDoubleConditions_CBCP` },
        ],
        examples: [
            `${CONTEXT}-savingsRepresentativeExample_CBCP`,
            `${CONTEXT}-savingsDoubleProfitabilityRepresentativeExample_CBCP`,
        ],
        rates: `${CONTEXT}-savingsRates_CBCP`,
        conditions: `${CONTEXT}-savingsConditions_CBCP`,
        doubleProfitability: `${CONTEXT}-savingsDoubleProfitability_CBCP`,
        doubleConditions: `${CONTEXT}-savingsDoubleConditions_CBCP`,
        example: `${CONTEXT}-savingsRepresentativeExample_CBCP`,
        doubleProfitabilityExample: `${CONTEXT}-savingsDoubleProfitabilityRepresentativeExample_CBCP`,
    }
}
